import { ComponentType } from 'react';
import Redirect from '../Component/redirect';
import SelfServe from '../Container/SelfServe';
import InboxV2 from '../Container/InboxV2';
import LeadsPage from '../Container/Leads/LeadsPage';
import Communities from '../Container/Communities/Communities';
import ChatbotSettings from '../Container/ChatbotSettings';
import VoiceCallAudit from '../Container/VoiceCallAudit';

type Role = 'ADMIN' | 'AGENT' | 'MANAGER' | 'SUPER_ADMIN';

interface RouteConfig {
  path: string;
  component: ComponentType;
  exact: boolean;
  acl: Role[];
}

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    component: InboxV2,
    exact: true,
    acl: ['ADMIN', 'AGENT']
  },
  {
    path: '/inbox',
    component: InboxV2,
    exact: true,
    acl: ['ADMIN', 'AGENT']
  },
  {
    path: '/communities',
    component: Communities,
    exact: true,
    acl: ['ADMIN']
  },
  {
    path: '/leads',
    component: LeadsPage,
    exact: true,
    acl: ['ADMIN', 'AGENT']
  },
  {
    path: '/oauth2/success',
    component: Redirect,
    exact: true,
    acl: ['ADMIN']
  },
  {
    path: '/admin',
    component: SelfServe,
    exact: true,
    acl: ['ADMIN', 'MANAGER']
  },
  {
    path: '/inbox/searchLead/:id',
    component: InboxV2,
    exact: true,
    acl: ['ADMIN', 'AGENT']
  },
  {
    path: '/chatbot-settings',
    component: ChatbotSettings,
    exact: true,
    acl: ['ADMIN', 'SUPER_ADMIN']
  },
  // Voice-call QA review (ZUM-3872). Reached one call at a time from Looker's
  // Voice Call Audit explore — there is no list page here, because Looker
  // already is that table.
  //
  // SUPER_ADMIN only — but note `PrivateRoute` does NOT read `acl` (it only
  // checks that the user has a role), so this entry is documentation. The
  // screen enforces the role itself, and the rb-backend-apis endpoints apply
  // `authorizeSuperAdmin`, which is what actually protects the data.
  {
    path: '/qa/voice-calls/:callSid',
    component: VoiceCallAudit,
    exact: true,
    acl: ['SUPER_ADMIN']
  }
];

export default routesConfig;
